<template>
    <!-- 首页 -->
    <div class="home">
        <div class="banner">
            <div class="shadow">
                <div class="banner-title" :class="EN ? 'banner-title-en' : ''">
                    <div>{{ $t('home.bannerTitle') }}</div>
                    <div>{{ $t('home.bannerSubTitle') }}</div>
                </div>
                <div class="banner-info">
                    <div>{{ $t('home.bannerInfo') }}</div>
                    <div>{{ $t('home.bannerSubInfo') }}</div>
                </div>
            </div>
            <div class="shadow" :class="EN ? 'shadow-en' : ''">
                <div class="banner-detail">
                    <div :class="EN ? 'banner-detail-en' : ''">{{ $t('home.bannerDetail') }}</div>
                    <div :class="EN ? 'banner-detail-en' : ''" class="banner-detail-sub">{{ $t('home.bannerSubDetail') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="member-info">
            <div class="member-item">
                <div class="member-left">
                    <img class="avator" src="@/assets/img/xu.png" alt="">
                    <div class="name">{{ $t('home.xu.name') }}</div>
                    <div class="info">{{ $t('home.xu.info') }}</div>
                    <div class="info">{{ $t('home.xu.subInfo') }}</div>
                </div>
                <div class="member-right">
                    <div>
                        <img class="xu-img1" src="@/assets/img/xu_2.png" alt="">
                        <img class="xu-img2" src="@/assets/img/xu_1.png" alt="">
                    </div>
                    <div class="member-right-detail">
                        <div>{{ $t('home.xu.detail1') }}</div>
                        <div>{{ $t('home.xu.detail2') }}</div>
                        <div>{{ $t('home.xu.detail3') }}</div>
                        <div>{{ $t('home.xu.detail4') }}</div>
                    </div>
                </div>
            </div>
            <div class="member-item">
                <div class="member-left">
                    <img class="avator" src="@/assets/img/chou.png" alt="">
                    <div class="name">{{ $t('home.chou.name') }}</div>
                    <div class="info">{{ $t('home.chou.info') }}</div>
                    <div class="info">{{ $t('home.chou.subInfo') }}</div>
                </div>
                <div class="member-right">
                    <div>
                        <img class="chou-img1" src="@/assets/img/chou_1.png" alt="">
                        <img class="chou-img2" src="@/assets/img/chou_2.png" alt="">
                    </div>
                    <div class="member-right-detail">
                        <div>{{ $t('home.chou.detail1') }}</div>
                        <div>{{ $t('home.chou.detail2') }}</div>
                        <div>{{ $t('home.chou.detail3') }}</div>
                        <div>{{ $t('home.chou.detail4') }}</div>
                        <div>{{ $t('home.chou.detail5') }}</div>
                    </div>
                </div>
            </div>
            <div class="member-item">
                <div class="member-left">
                    <img class="avator" src="@/assets/img/lee.png" alt="">
                    <div class="name">{{ $t('home.lee.name') }}</div>
                    <div class="info">{{ $t('home.lee.info') }}</div>
                    <div class="info">{{ $t('home.lee.subInfo') }}</div>
                </div>
                <div class="member-right">
                    <div>
                        <img class="lee-img1" src="@/assets/img/lee_1.png" alt="">
                        <img class="lee-img2" src="@/assets/img/lee_2.png" alt="">
                    </div>
                    <div class="member-right-detail">
                        <div>{{ $t('home.lee.detail1') }}</div>
                        <div>{{ $t('home.lee.detail2') }}</div>
                        <div>{{ $t('home.lee.detail3') }}</div>
                        <div>{{ $t('home.lee.detail4') }}</div>
                        <div>{{ $t('home.lee.detail5') }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'Home',
    props: {
    },
    computed: {
        EN() {
            return this.$i18n.locale === 'en';
        }
    }
}
</script>
  
<style scoped>
@font-face {
    font-family: 'Arial-regular';
    src: url('~@/assets/font/Arial-regular.ttf') format('truetype');
}

@font-face {
    font-family: 'HarmonyOS_Sans_Condensed';
    src: url('~@/assets/font/HarmonyOS_Sans_Condensed_Medium.ttf') format('truetype');
}

@font-face {
    font-family: 'AlibabaPuHui-regular';
    src: url('~@/assets/font/Alibaba-PuHuiTi-Regular.ttf') format('truetype');
}

.banner {
    display: flex;
    padding: 90px 36px;
    margin-bottom: 90px;
    width: 100%;
    height: 538px;
    background: url('https://i.gsxcdn.com/2117383757_t9eg5zq9.png') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
}

.shadow {
    margin: 0 auto;
    padding: 45px 0;
    width: 1000px;
    text-align: center;
    box-sizing: border-box;
    background-color: rgba(23, 102, 153, 0.5);
}

.shadow:first-child {
    margin-right: 20px;
}

.shadow-en {
    padding: 0 !important;
    display: flex;
    align-items: center;
}

.banner-title {
    margin-bottom: 40px;
    color: #FFF;
    font-size: 36px;
    font-family: 'Arial-regular';
    text-align: center;
}

.banner-title-en {
    font-size: 32px !important;
}

.banner-info {
    font-size: 17px;
    color: #FFF;
    line-height: 32px;
}

.banner-detail {
    padding: 0 10px;
    font-size: 17px;
    line-height: 32px;
    color: #FFF;
    text-align: left;
    font-family: 'AlibabaPuHui-regular';
}

.banner-detail-sub {
    margin-top: 10px;
    line-height: 32px;
    font-family: 'AlibabaPuHui-regular';
}

.banner-detail-en {
    font-size: 15px !important;
    line-height: 22px !important;
}

.member-item {
    padding: 52px 0;
    width: 100%;
    border: 1px solid #AEAEAE;
    box-sizing: border-box;
    font-family: 'HarmonyOS_Sans_Condensed';
}

.member-left {
    margin-right: 54px;
    width: 223px;
    text-align: center;
}

.member-right-detail>div {
    margin-top: 10px;
}

.member img {
    display: inherit;
    margin: 0 auto;
    width: 810px;
}

.member-info>div {
    padding: 30px 20px 20px 60px;
    border: 1px solid #AEAEAE;
    border-top: 0;
}

.member-info>div:first-child {
    border: 1px solid #AEAEAE;
}

.member-info .name {
    font-size: 40px;
    color: #101010;
}

.member-info .info {
    font-size: 17px;
    color: #101010;
}

.member-item {
    display: flex;
}

.avator {
    margin-right: 60px;
    width: 223px;
    height: 305px;
}

.xu-img1 {
    margin-right: 45px;
    width: 223px;
    height: 259px;
}

.xu-img2 {
    width: 357px;
    height: 267px;
}

.detail {
    color: #000;
    font-size: 24px;
}

.detail>div {
    margin-bottom: 10px;
}

.xu .detail {
    padding: 0 36px;
}

.chou .detail,
.lee .detail {
    margin-top: 36px;
    padding-right: 36px;
}

.chou-img1 {
    margin-right: 34px;
    width: 291px;
    height: 200px;
}

.chou-img2 {
    width: 286px;
    height: 200px;
}

.lee-img1 {
    margin-right: 36px;
    width: 277px;
    height: 200px;
}

.lee-img2 {
    width: 286px;
    height: 200px;
}

.title {
    margin-top: 24px;
}
</style>